import store from '@/store';
import {
  CLEAR_ACCOUNT_ISLOADING,
  CLEAR_ORGANIZATION_ISLOADING,
} from '@/store/action_types';

export const resetLoaders = () => {
  store.dispatch(CLEAR_ACCOUNT_ISLOADING);
  store.dispatch(CLEAR_ORGANIZATION_ISLOADING);
};
